import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  MemberPreferencesDto,
  MemberPreferencesService,
} from '@services/MemberPreferencesService'

export interface MemberPreferencesState {
  preferences: MemberPreferencesDto | null
}

const initialState: MemberPreferencesState = {
  preferences: null,
}

export const doGetMemberPreferences = createAsyncThunk<
  MemberPreferencesDto,
  void
>('memberPreferences/get', async () => {
  const response = await MemberPreferencesService.getMemberPreferences()
  return response
})

export const memberPreferencesSlice = createSlice({
  name: 'memberPreferences',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetMemberPreferences.fulfilled, (state, action) => {
      state.preferences = action.payload
    })
  },
})

export default memberPreferencesSlice.reducer
